<form [formGroup]="form">
  <div class="flex flex-col">
    <div class="date-type-options flex flex-col">
      <span class="font-bold text-gray-600">DATE TYPE</span>
      @for (dateType of dateTypes; track dateType.value) {
        <mat-checkbox
          [checked]="form.controls.dateType.value === dateType.value"
          (change)="onDateTypeChange(dateType.value, $event.checked)">
          {{ dateType.label }}
        </mat-checkbox>
      }
    </div>

    @if (form.controls.dateType.value !== null) {
      <div class="my-4 flex flex-col">
        <span class="font-bold text-gray-600 my-4">DATE RANGE</span>
        <label>
          Start date
        </label>
        <input class="form-input" type="date" min="2026-01-01" formControlName="startDate">
      </div>
      <div class="my-4 flex flex-col">
        <label>
          End date
        </label>
        <input class="form-input" type="date" min="2026-01-01" formControlName="endDate">
      </div>
    }
  </div>
</form>
